import { render, staticRenderFns } from "./VolumeReverseView.vue?vue&type=template&id=a0b1da96&"
import script from "./VolumeReverseView.vue?vue&type=script&lang=js&"
export * from "./VolumeReverseView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports